import * as React from 'react';
import TicketTimerService from './TicketTimerService';
import {formatTimeDiff} from '../../ChronicCareManagement/module-components/StopTimerDialog/TimerUtils';

const TicketRunningTime = ({startTime}: {startTime: Date}): JSX.Element => {
  const timerService = TicketTimerService.getInstance(startTime);

  const [duration, setDuration] = React.useState(
    timerService.getCurrentTimerValue()
  );

  React.useEffect(() => {
    const subscription = timerService.timerValue$.subscribe(value => {
      setDuration(value);
    });
    timerService.subscribe();
    return () => {
      subscription.unsubscribe();
      timerService.unsubscribe();
    };
  }, [timerService]);

  return <p>{formatTimeDiff(duration)}</p>;
};

export default TicketRunningTime;
